import React from 'react';

const SkeletonBanners_a = () => {
    return (
        <div className="skeleton-banners_a-wrapper xmt-20">
            <div className="container">
                <div className="banner_a-wrapper d-flex align-items-center">
                    <div className="banner-sk br-4 skeleton-loading orange-banner xpx-10 d-flex justify-content-between align-items-center">
                        <div className="text-sk br-4 skeleton-loading"></div>
                        <div className="button-sk br-5 skeleton-loading"></div>
                    </div>
                    <div className="banner-sk xmr-6 br-4 skeleton-loading purple-banner xpx-10 d-flex justify-content-between align-items-center">
                        <div className="text-sk br-4 skeleton-loading"></div>
                        <div className="button-sk br-5 skeleton-loading"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SkeletonBanners_a;
